import { available_guest_orbits, is_room_activated } from './StationUtilities';

const AMENITY_IDS = [ 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24 ];
export const ARISTOCRATS = [ 51, 52, 53, 54, 55, 56 ];
export const EXPANSIONS = {
    1: ARISTOCRATS
}
export const EXPANSION_NAMES = {
    1: 'Aristocrats'
}
const BED_IDS = [ 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 57, 58 ];
const FACTION_BEDS = [ 25, 27, 29, 31, 33, 35, 26, 28, 30, 32, 34, 36 ];
export const CARD_NAMES = [ null,
    'Deep Guest Observatory', 'Deep Vanguard Casino',
    'Deep Guest Arena', 'Deep Pirate Bar', 'Deep Guest Altar',
    'Deep Seeker Zoo', 'Stem Guest Observatory',
    'Stem Vanguard Casino', 'Stem Guest Arena', 'Stem Pirate Bar',
    'Stem Guest Altar', 'Stem Seeker Zoo',
    'Hex Guest Observatory', 'Hex Vanguard Casino',
    'Hex Guest Arena', 'Hex Pirate Bar', 'Hex Guest Altar',
    'Hex Seeker Zoo', 'Dread Guest Observatory',
    'Dread Vanguard Casino', 'Dread Guest Arena', 'Dread Pirate Bar',
    'Dread Guest Altar', 'Dread Seeker Zoo',
    'Honored Guest Observatory', 'Honored Vanguard Casino',
    'Honored Guest Arena', 'Honored Pirate Bar',
    'Honored Guest Altar', 'Honored Seeker Zoo',
    'Seed Guest Observatory', 'Seed Vanguard Casino',
    'Seed Guest Arena', 'Seed Pirate Bar', 'Seed Guest Altar',
    'Seed Seeker Zoo', 'Upgraded Ghost Card', 'Ghost Card',
    'Deep Freighter', 'Stem Freighter', 'Hex Freighter',
    'Dread Freighter', 'Honored Freighter', 'Seed Freighter',
    'Deep Refugee', 'Stem Refugee', 'Hex Refugee',
    'Dread Refugee', 'Honored Refugee', 'Seed Refugee',
    'Deep Aristocrat', 'Stem Aristocrat', 'Hex Aristocrat',
    'Dread Aristocrat', 'Honored Aristocrat', 'Seed Aristocrat',
    'Deep Crowd', 'Stem Crowd', 'Hex Crowd', 'Dread Crowd',
    'Honored Crowd', 'Seed Crowd', 'Deep Freelancer',
    'Stem Freelancer', 'Hex Freelancer', 'Dread Freelancer',
    'Honored Freelancer', 'Seed Freelancer' ];
export const CARD_FACTIONS = [ null,
    1, 1, 1, 1, 1, 1,
    2, 2, 2, 2, 2, 2,
    3, 3, 3, 3, 3, 3,
    4, 4, 4, 4, 4, 4,
    5, 5, 5, 5, 5, 5,
    6, 6, 6, 6, 6, 6,
    null, null,
    1, 2, 3, 4, 5, 6,
    1, 2, 3, 4, 5, 6,
    1, 2, 3, 4, 5, 6,
    1, 2, 3, 4, 5, 6,
    1, 2, 3, 4, 5, 6 ];
const UPGRADED_LODGING_IDS = [ 37, 39, 41, 43, 45, 47 ];
export const UNUPGRADED_LODGING_IDS = [ 38, 40, 42, 44, 46, 48 ];
const CARD_AMENITIES = [ null,
    14, 16, 18, 20, 22, 24,
    14, 16, 18, 20, 22, 24,
    14, 16, 18, 20, 22, 24,
    14, 16, 18, 20, 22, 24,
    14, 16, 18, 20, 22, 24,
    14, 16, 18, 20, 22, 24,
    null, null,
    null, null, null, null, null, null,
    null, null, null, null, null, null,
    null, null, null, null, null, null,
    null, null, null, null, null, null,
    null, null, null, null, null, null ];
const UPGRADED_AMENITIY_IDS = [ 13, 15, 17, 19, 21, 23 ];
export const UNUPGRADED_AMENITY_IDS = [ 14, 16, 18, 20, 22, 24 ];
const UPGRADED_FACTION_BED_IDS = [ 25, 27, 29, 31, 33, 35 ];
export const UNUPGRADED_FACTION_BED_IDS = [ 26, 28, 30, 32, 34, 36 ];
export const PIRATES = [ 4, 10, 16, 22, 28, 34 ];
export const GHOST_CARDS = [ 37, 38 ];
export const ANGRY_GHOST = 37;
export const SATISFIED_GHOST = 38;
export const SPECIAL_GUESTS = [ 2, 4, 6, 8, 10, 12, 14, 16, 18, 20,
    22, 24, 26, 28, 30, 32, 34, 36 ];
export const SEEKERS = [ 6, 12, 18, 24, 30, 36 ];

export const REGULAR_GUESTS = [1, 3, 5, 7, 9, 11, 13, 15, 17, 19, 21,
    23, 25, 27, 29, 31, 33, 35];
const FREIGHTERS = [39, 40, 41, 42, 43, 44]
const REFUGEES = [45, 46, 47, 48, 49, 50]
const CROWDS = [57, 58, 59, 60, 61, 62]
const FREELANCERS = [63, 64, 65, 66, 67, 68]
export const VANGUARDS = [2, 8, 14, 20, 26, 32];

export const ALL_GUESTS = [
    ...REGULAR_GUESTS, ...SPECIAL_GUESTS,
    ...REFUGEES, ...ARISTOCRATS, ...CROWDS,
    ...FREELANCERS
]  // specifically not freighters.

export const GUESTS_WHICH_ARE_SAFE_TO_DISCARD = [
    ...REGULAR_GUESTS, ...ARISTOCRATS
];
// todo: add other expansions.

export function do_i_have_matching_lodging(lodging, card_id) {
    const faction_id = CARD_FACTIONS[card_id];
    const faction_index = faction_id - 1;
    const unupgraded_lodging = UNUPGRADED_LODGING_IDS[faction_index];
    const upgraded_lodging = UPGRADED_LODGING_IDS[faction_index];
    const possible_lodgings = [ unupgraded_lodging, upgraded_lodging ];
    const filteredArray = lodging.filter(value => possible_lodgings.includes(value));
    return filteredArray.length > 0;
}

export function do_i_have_matching_amenity(station, card_id) {
    const amenity_id = CARD_AMENITIES[card_id];
    if (!amenity_id) {
        return false;
    }
    const amenity_index = UNUPGRADED_AMENITY_IDS.indexOf(amenity_id);
    const unupgraded = UNUPGRADED_AMENITY_IDS[amenity_index];
    const upgraded = UPGRADED_AMENITIY_IDS[amenity_index];
    const possible = [ unupgraded, upgraded ];
    const filteredArray = station.filter(value => possible.includes(value));
    return filteredArray.length > 0;
}

export function do_i_have_matching_bed(station, card_id) {
    const faction_id = CARD_FACTIONS[card_id];
    const faction_index = faction_id - 1;
    const unupgraded = UNUPGRADED_FACTION_BED_IDS[faction_index];
    const upgraded = UPGRADED_FACTION_BED_IDS[faction_index];
    const possible = [ unupgraded, upgraded ];
    const filteredArray = station.filter(value => possible.includes(value));
    return filteredArray.length > 0;
}


export function available_docks_for_guest(docks, card_id) {
    let is_seeker = SEEKERS.includes(card_id);
    let available_docs = [];
    docks.forEach((dock_card, dock_index) => {
        let valid = dock_card === null;
        if (!valid && is_seeker) {
            valid = GHOST_CARDS.includes(dock_card);
        }
        if (valid) {
            available_docs.push(dock_index);
        }
    });
    return available_docs;
}

export function availableDocksForGhost(docks) {
    let availableDocks = [];
    docks.forEach((cardId, dock_index) => {
        let valid = cardId === null;
        if (!valid && cardId === SATISFIED_GHOST) valid = true;
        if (valid) {
            availableDocks.push(dock_index);
        }
    });
    return availableDocks;
}


export function get_points_for_card(
    station, robot_assignments, existing_lodging, card_id, dock_index,
    assume_activated=false, assume_lodging=false) {
    if (GHOST_CARDS.includes(card_id)) {
        if (card_id === ANGRY_GHOST) {
            return { points: -1, satisfied: false, statement: 'Angry Ghost: -1 Snohe and Dock Blocked.' };
        } else {
            return { points: 0, satisfied: true, statement: 'Satisfied Ghost, Dock Blocked.' };
        }
    }

    let is_pirate = PIRATES.includes(card_id);
    let card_name = CARD_NAMES[card_id];
    let adjacent_room_index = (station.length) - 4 + dock_index;
    let adjacent_room_id = station[adjacent_room_index];
    let is_compatible = _compatible_adjacent_room_is_activated(
        station, robot_assignments, card_id, adjacent_room_index,
        assume_activated=assume_activated);
    let points = 0;
    let satisfied = false;
    let statement = `${card_name} `;
    if (is_compatible) {
        let lodging = matching_lodging_points(existing_lodging, card_id,
            assume_lodging=assume_lodging);
        if (lodging.matched) {
            satisfied = true;
            statement += `pays ${1} for Docking, `;
            points += 1;
            if (BED_IDS.includes(adjacent_room_id) || is_pirate) {
                points += lodging.points;
                statement += `pays ${lodging.points} for Lodging, `;
                let points_from_bed = bed_points(
                    station, robot_assignments,
                    card_id, adjacent_room_id,
                    adjacent_room_index,
                    assume_activated=assume_activated);
                points += points_from_bed;
                if (points_from_bed > 0) {
                    statement += (`${points_from_bed} extra for a Matching Faction Bed, `);
                }
                let points_from_amenity = amenity_points(station, robot_assignments, card_id,
                    assume_activated=assume_activated);
                points += points_from_amenity;
                statement += `${points_from_amenity} for Amenities, `;
                let is_aristocrat = ARISTOCRATS.includes(card_id);
                if (is_aristocrat) {
                    points *= 2;
                    statement += `Aristocrat Doubles, `;
                }
            } else {
                points += 1;
                statement += `pays 1 for Adjacent Matching Amenity, `;
            }
            statement += `a total of ${points}.`;

        } else {
            if (SPECIAL_GUESTS.includes(card_id)) {
                statement += `Will attack unless Satisfied.`;
                points = 'Danger';
            } else {
                statement += `No Lodging for a total of 0.`;
            }
        }
    } else {
        if (SPECIAL_GUESTS.includes(card_id)) {
            statement += `Will attack unless Satisfied.`;
            points = 'Danger';
        } else {
            statement += `Unsatisfied for a total of 0.`;
        }
    }
    return { points: points, satisfied: satisfied, statement: statement };
}

export function _compatible_adjacent_room_is_activated(
    station,
    robot_assignments,
    card_id,
    adjacent_room_index,
    assume_activated=false,
) {
    let is_pirate = PIRATES.includes(card_id);
    if (is_pirate) {
        return true;
    }
    let adjacent_room_id = station[adjacent_room_index];
    if (!adjacent_room_id) {
        return false;
    }
    let room_activated = is_room_activated(station, adjacent_room_index, robot_assignments);
    if (!room_activated && !assume_activated) {
        return false;
    }

    if (BED_IDS.includes(adjacent_room_id)) {
        let is_aristocrat = ARISTOCRATS.includes(card_id);
        if (is_aristocrat) {
            return FACTION_BEDS.includes(adjacent_room_id);
        } else {
            return true;
        }
    }

    if (AMENITY_IDS.includes(adjacent_room_id)) {
        let card_amenity = CARD_AMENITIES[card_id];
        let amenity_index;
        if (UNUPGRADED_AMENITY_IDS.includes(adjacent_room_id)) {
            amenity_index = UNUPGRADED_AMENITY_IDS.indexOf(adjacent_room_id);
        } else {
            amenity_index = UPGRADED_AMENITIY_IDS.indexOf(adjacent_room_id);
        }
        let room_amenity = UNUPGRADED_AMENITY_IDS[amenity_index];
        if (card_amenity === room_amenity) {
            return true;
        }

    }
    return false;
}

export function matching_lodging_points(lodging, card_id, assume_lodging=false) {
    let matched = assume_lodging;
    let points = 0;
    let faction_id = CARD_FACTIONS[card_id];
    let faction_index = faction_id - 1;
    let unupgraded_lodging = UNUPGRADED_LODGING_IDS[faction_index];
    let upgraded_lodging = UPGRADED_LODGING_IDS[faction_index];
    let possible_lodgings = [ unupgraded_lodging, upgraded_lodging ];
    lodging.forEach((lodging_room) => {
        if (lodging_room === null) {
            return;
        }
        if (possible_lodgings.includes(lodging_room)) {
            matched = true;
            if (lodging_room === upgraded_lodging) {
                points += 1;
            }
        }
    });
    return { matched: matched, points: points };
}

export function bed_points(station, robot_assignments,
                           card_id, bed_room_id, adjacent_room_index,
                           assume_activated=false) {
    let points = 0;
    if (FACTION_BEDS.includes(bed_room_id)) {
        let bed_faction_id;
        if (UNUPGRADED_FACTION_BED_IDS.includes(bed_room_id)) {
            bed_faction_id = UNUPGRADED_FACTION_BED_IDS.indexOf(bed_room_id) + 1;
        } else {
            bed_faction_id = UPGRADED_FACTION_BED_IDS.indexOf(bed_room_id) + 1;
        }
        if (bed_faction_id === CARD_FACTIONS[card_id]) {
            if (is_room_activated(station, adjacent_room_index, robot_assignments) || assume_activated) {
                points += 1;
            }
        }
    }
    return points;
}

export function amenity_points(station, robot_assignments, card_id,
                               assume_activated=false) {
    let activated_amenities = [];
    station.forEach((room_id, station_location_index) => {
        if (room_id) {
            if (AMENITY_IDS.includes(room_id)) {
                if (is_room_activated(station, station_location_index, robot_assignments) || assume_activated) {
                    activated_amenities.push(room_id);
                }
            }
        }
    });
    let unupgraded_amenity_room_id = CARD_AMENITIES[card_id];
    let matching_rooms = [];
    if (unupgraded_amenity_room_id) {
        let index = UNUPGRADED_AMENITY_IDS.indexOf(unupgraded_amenity_room_id);
        let upgraded_amenity_room_id = UPGRADED_AMENITIY_IDS[index];
        matching_rooms = [ unupgraded_amenity_room_id, upgraded_amenity_room_id ];
    }
    let points = activated_amenities.length;
    activated_amenities.forEach((room_id) => {
        if (matching_rooms.includes(room_id)) {
            points += 1;
        }
    });
    return points;
}


function cardTradelaneData(cardData, tradelanes, tradelaneIndex) {
    let willBurn = false;
    let isBurned = false;
    let notBuried = false;
    if (cardData.id) {
        willBurn = Boolean([ 4, 5, 10, 11 ].includes(tradelaneIndex));
        notBuried = available_guest_orbits(tradelanes).includes(tradelaneIndex);
    }
    cardData.tradelaneIndex = tradelaneIndex;
    cardData.willBurn = willBurn;
    cardData.isBurned = isBurned;
    cardData.notBuried = notBuried;
}


function cardPlayerData(cardData, gamePlayerId,
        station, lodging, docks, turnStatus, robotAssignments) {
    let matchingLodging = false;
    let matchingAmenity = false;
    let matchingBed = false;
    let availableDocks = [];
    let dockPayouts = [ 0, 0, 0, 0 ];
    let dock = null;
    let pointData = null;
    let isGhost = false;
    let isSpecial = false;
    let isSeeker = false;

    const cardId = cardData.id;
    if (cardId) {
        isGhost = GHOST_CARDS.includes(cardId);
        isSpecial = SPECIAL_GUESTS.includes(cardId);
        isSeeker = SEEKERS.includes(cardId);
        matchingLodging = do_i_have_matching_lodging(lodging, cardId);
        matchingAmenity = do_i_have_matching_amenity(station, cardId);
        matchingBed = do_i_have_matching_bed(station, cardId);
        if (docks.includes(cardId)) {
            dock = docks.indexOf(cardId);
            pointData = get_points_for_card(
                station, robotAssignments, lodging, cardId, dock)
        } else {
            availableDocks = available_docks_for_guest(docks, cardId);
            // Per-dock payout the seated player would collect RIGHT NOW
            // if this river guest docked here. Surfaces what the AI sees
            // (get_points_for_card) so humans read the same numbers.
            // NO ASSUME -- Michael's explicit rule: "what's real, no
            // assume." Both assume args below are literal false for EVERY
            // card type, including Vanguards. This is the display contract
            // (current reality), NOT bestDockForCard's AI planning lens --
            // a Vanguard with no matching permit shows 0, and the repaint
            // shows the new reality the instant state changes.
            for (let i = 0; i < dockPayouts.length; i++) {
                if (!availableDocks.includes(i)) {
                    continue;
                }
                let dockPointData = get_points_for_card(
                    station, robotAssignments, lodging, cardId, i, false, false);
                // get_points_for_card returns the string 'Danger' in
                // .points for unsatisfiable special guests -- always with
                // satisfied:false, so this guard (satisfied + integer +
                // positive) zeroes it without ever comparing the literal.
                if (dockPointData.satisfied === true &&
                        Number.isInteger(dockPointData.points) &&
                        dockPointData.points > 0) {
                    dockPayouts[i] = dockPointData.points;
                }
            }
        }
    }
    cardData.gamePlayerId = gamePlayerId;
    cardData.dock = dock;
    cardData.pointData = pointData;
    cardData.matchingLodging = matchingLodging;
    cardData.matchingAmenity = matchingAmenity;
    cardData.matchingBed = matchingBed;
    cardData.turnStatus = turnStatus;
    cardData.availableDocks = availableDocks;
    cardData.dockPayouts = dockPayouts;
    cardData.isGhost = isGhost;
    cardData.isSpecial = isSpecial;
    cardData.isSeeker = isSeeker;
}


export function getCardForPlayer(cardData, gamePlayerData) {
    return cardPlayerData(cardData, gamePlayerData.id,
        gamePlayerData.station, gamePlayerData.lodging,
        gamePlayerData.docks, gamePlayerData.turn_status,
        gamePlayerData.robot_assignments);
}


export function getSingleCardData(cardId, gameData, gamePlayerData) {
    let cardData = getCardTemplate(cardId);
    let found = false;
    if (gameData.orbits.includes(cardId)) {
        cardData.tradelaneIndex = gameData.orbits.indexOf(cardId);
        cardTradelaneData(cardData, gameData.orbits, cardData.tradelaneIndex);
        cardData.guestDeck = true;
        found = true;
    } else if (gameData.guest_deck.includes(cardId)) {
        cardData.guestDeck = true;
        found = true;
    } else if (gameData.discard_deck.includes(cardId)) {
        cardData.discardDeck = true;
        found = true;
    } else if (gameData.burn_deck.includes(cardId)) {
        cardData.burnDeck = true;
        found = true;
    } else if (gameData.draft_choices.includes(cardId)) {
        cardData.draftChoices = true;
        found = true;
    } else {
        gameData.gameplayer_set.forEach((playerData) => {
            if (playerData.docks.includes(cardId)) {
                cardData.dock = playerData.docks.indexOf(cardId);
                cardData.gamePlayerId = playerData.id;
                found = true;
            }
        });
    }
    cardData.found = found;

    getCardForPlayer(cardData, gamePlayerData);
    return cardData;
}



function getCardTemplate(cardId) {
    return {
        id: cardId,
        name: CARD_NAMES[cardId],
        faction: CARD_FACTIONS[cardId],
        amenity: CARD_AMENITIES[cardId],
        isAristocrat: ARISTOCRATS.includes(cardId),
        found: false,
        guestDeck: false,
        discardDeck: false,
        isBurned: false,
        isDrafted: false,

        tradelaneIndex: null,
        willBurn: false,
        notBuried: false,

        gamePlayerId: null,
        turnStatus: null,
        matchingLodging: false,
        matchingAmenity: false,
        matchingBed: false,
        availableDocks: [],
        dockPayouts: [ 0, 0, 0, 0 ],

        dock: null,
        pointData: null,

        isGhost: false,
        isSpecial: false,
        isSeeker: false,
    }
}


export function getTradelaneCards(tradelanes) {
    return tradelanes.map((cardId, tradelaneIndex) => {
        if (cardId) {
            let cardData = getCardTemplate(cardId);
            cardTradelaneData(cardData, tradelanes, tradelaneIndex);
            return cardData;
        } else {
            return {id: null, tradelaneIndex: tradelaneIndex}
        }
    });
}


export function getTradelaneCardsForPlayer(gameData, gamePlayerData) {
    return gameData.orbits.map((cardId, tradelaneIndex) => {
        if (cardId) {
            let cardData = getCardTemplate(cardId);
            cardTradelaneData(cardData, gameData.orbits, tradelaneIndex);
            getCardForPlayer(cardData, gamePlayerData);
            return cardData;
        } else {
            return {
                id: null,
                tradelaneIndex: tradelaneIndex,
                gamePlayerId: gamePlayerData.id,
                dockPayouts: [ 0, 0, 0, 0 ],
            }
        }
    });
}

export function getAllCards(gameData) {
    let allCards = {}
    gameData.orbits.forEach((cardId, tradelaneIndex) => {
        let cardData = getCardTemplate(cardId);
        cardTradelaneData(cardData, gameData.orbits, tradelaneIndex);
        allCards[cardId] = cardData;
    });
    gameData.guest_deck.forEach((cardId) => {
        let cardData = getCardTemplate(cardId);
        cardData.guestDeck = true;
        allCards[cardId] = cardData;
    });
    gameData.discard_deck.forEach((cardId) => {
        let cardData = getCardTemplate(cardId);
        cardData.discardDeck = true;
        allCards[cardId] = cardData;
    });
    gameData.burn_deck.forEach((cardId) => {
        let cardData = getCardTemplate(cardId);
        cardData.isBurned = true;
        allCards[cardId] = cardData;
    });
    gameData.draft_choices.forEach((cardId) => {
        let cardData = getCardTemplate(cardId);
        cardData.isDrafted = true;
        allCards[cardId] = cardData;
    });
    gameData.gameplayer_set.forEach((gamePlayerData) => {
        gamePlayerData.docks.forEach((cardId, dock) => {
            if (cardId && !GHOST_CARDS.includes(cardId)){
                let cardData = getCardTemplate(cardId);
                cardData.dock = dock;
                allCards[cardId] = cardData;
            }
        });
    });
}


export function getAllCardsForPlayer(gameData, gamePlayerData) {
    let allCards = {}
    let cardData;
    gameData.orbits.forEach((cardId, tradelaneIndex) => {
        if (cardId) {
            cardData = getCardTemplate(cardId);
            cardTradelaneData(cardData, gameData.orbits, tradelaneIndex);
            getCardForPlayer(cardData, gamePlayerData);
            cardData.found = true;
            allCards[cardId] = cardData;
        }
    });
    gameData.guest_deck.forEach((cardId) => {
        let cardData = getCardTemplate(cardId);
        cardData.guestDeck = true;
        cardData.found = true;
        getCardForPlayer(cardData, gamePlayerData);
        allCards[cardId] = cardData;
    });
    gameData.discard_deck.forEach((cardId) => {
        let cardData = getCardTemplate(cardId);
        cardData.discardDeck = true;
        cardData.found = true;
        getCardForPlayer(cardData, gamePlayerData);
        allCards[cardId] = cardData;
    });
    gameData.burn_deck.forEach((cardId) => {
        let cardData = getCardTemplate(cardId);
        cardData.isBurned = true;
        cardData.found = true;
        allCards[cardId] = cardData;
    });
    gameData.draft_choices.forEach((cardId) => {
        let cardData = getCardTemplate(cardId);
        cardData.isDrafted = true;
        cardData.found = true;
        getCardForPlayer(cardData, gamePlayerData);
        allCards[cardId] = cardData;
    });
    gameData.gameplayer_set.forEach((gamePlayerData) => {
        gamePlayerData.docks.forEach((cardId, dock) => {
            if (cardId && !GHOST_CARDS.includes(cardId)){
                let cardData = getCardTemplate(cardId);
                cardData.dock = dock;
                cardData.found = true;
                getCardForPlayer(cardData, gamePlayerData);
                allCards[cardId] = cardData;
            }
        });
    });
    return allCards;
}


function isTradelaneCardBuried(tradelanes, tradelaneIndex) {
    let available = false;
    const cardId = tradelanes[tradelaneIndex];
    if (cardId != null) {
        if (tradelaneIndex < 6) {
            let outerCard = tradelanes[tradelaneIndex + 6];
            available = outerCard === null;
        } else {
            available = true;
        }
    }
    return available;
}


function isDockAvailableForCard(gamePlayerData, dock, cardId) {
    const dockedCard = gamePlayerData.docks[dock];
    if (!dockedCard) return true;
    return GHOST_CARDS.includes(dockedCard) && SEEKERS.includes(cardId);
}


export function scoredTradelanes(
        gameData, gamePlayerData,
        assumeActivated = false,
        assumeAvailable = false,
        assumeLodging = false) {
    const tradelanes = gameData.orbits;
    let scoredLanes = [ 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0 ];
    let scoredDocks = [
        null, null, null, null, null, null,
        null, null, null, null, null, null ];
    tradelanes.forEach((tradelaneCard, tradelaneIndex) => {
        if (tradelaneCard) {
            let available = isTradelaneCardBuried(tradelanes, tradelaneIndex);
            if (available || assumeAvailable) {
                let bestPoints = 0;
                let bestDock = null;
                gamePlayerData.docks.forEach((dockedCardId, dockIndex) => {
                    if (!isDockAvailableForCard(gamePlayerData, dockIndex, tradelaneCard)) {
                        return;  // continue
                    }
                    let cardData = get_points_for_card(
                        gamePlayerData.station,
                        gamePlayerData.robot_assignments,
                        gamePlayerData.lodging,
                        tradelaneCard, dockIndex,
                        assumeActivated,
                        assumeLodging);
                    if (cardData.satisfied && cardData.points > bestPoints) {
                        bestPoints = cardData.points;
                        bestDock = dockIndex;
                    }
                });
                scoredLanes[tradelaneIndex] = bestPoints;
                scoredDocks[tradelaneIndex] = bestDock;
            }
        }
    });
    return {scoredLanes: scoredLanes, scoredDocks: scoredDocks}
}

export function bestDockForCard(gamePlayerData, cardId) {
    let bestPoints = 0;
    let bestDock = null;
    gamePlayerData.docks.forEach((dockedCardId, dockIndex) => {
        if (!isDockAvailableForCard(gamePlayerData, dockIndex, cardId)) {
            return;  // continue
        }
        let cardData = get_points_for_card(
            gamePlayerData.station,
            gamePlayerData.robot_assignments,
            gamePlayerData.lodging,
            cardId, dockIndex,
            false,
            VANGUARDS.includes(cardId));
        if (cardData.satisfied && cardData.points > bestPoints) {
            bestPoints = cardData.points;
            bestDock = dockIndex;
        }
    });
    return { dock:bestDock, points: bestPoints };
}

function highestScoringTradelaneAndDock(tradelaneScoreData) {
    const maxPoints = Math.max(...tradelaneScoreData.scoredLanes);
    if (maxPoints === 0) {
        return {tradelane: null, dock: null, maxPoints: 0};
    }
    const tradelane = tradelaneScoreData.scoredLanes.indexOf(maxPoints);
    const dock = tradelaneScoreData.scoredDocks[tradelane];
    return {tradelane: tradelane, dock: dock, maxPoints: maxPoints};
}


export function highestScoringAvailableCard(gameController,
        assumeActivated=false, assumeLodging=false) {
    const tradelaneScoreData = scoredTradelanes(
        gameController.gameData,
        gameController.gamePlayerData,
        assumeActivated,
        assumeLodging
    );
    return highestScoringTradelaneAndDock(tradelaneScoreData);
}


export function getPlayerDocksData(gamePlayerData) {
    return gamePlayerData.docks.map((cardId, dockIndex) => {
        if (cardId) {
            let cardData = getCardTemplate(cardId);
            getCardForPlayer(cardData, gamePlayerData);
            return cardData;
        } else {
            return {id: null, dock: dockIndex}
        }
    });
}


export function availableSpecialGuests(gameData) {
    const available = available_guest_orbits(gameData.orbits);
    let lanes = [];
    gameData.orbits.forEach((cardId, tradelaneIndex) => {
        if (available.includes(tradelaneIndex) && cardId && SPECIAL_GUESTS.includes(cardId)) lanes.push(tradelaneIndex);
    })
    return lanes;
}


export function availableSeekers(gameData) {
    const available = available_guest_orbits(gameData.orbits);
    let lanes = [];
    gameData.orbits.forEach((cardId, tradelaneIndex) => {
        if (available.includes(tradelaneIndex) && cardId && SEEKERS.includes(cardId)) lanes.push(tradelaneIndex);
    })
    return lanes;
}

export function availableVanguards(gameData) {
    const available = available_guest_orbits(gameData.orbits);
    let lanes = [];
    gameData.orbits.forEach((cardId, tradelaneIndex) => {
        if (available.includes(tradelaneIndex) && cardId && VANGUARDS.includes(cardId)) lanes.push(tradelaneIndex);
    })
    return lanes;
}


export function availableLaneCards(gameData) {
    const available = available_guest_orbits(gameData.orbits);
    return available.map((tradelaneIndex ) => gameData.orbits[tradelaneIndex]);
}


export function emptyAvailableLanes(gameData) {
    let empty = [];
    gameData.orbits.forEach((cardId, tradelaneIndex) => {
        if (!cardId && tradelaneIndex < 6) empty.push(tradelaneIndex)
    });
    return empty;
}
